import { type  AxiosInstance, type InternalAxiosRequestConfig, isAxiosError } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { OnboardingApiError, UNKNOWN_ONBOARDING_API_ERROR_CODE } from './errors';
import { captureException } from '@/services/sentry.service';
import Cookies from "js-cookie";
import { CUSTOM_AUTH_NAME } from '@/lib/constants';

declare const __BOBTAIL_APP_VERSION__: string;

export function addRequestIdHeader (config: InternalAxiosRequestConfig) {
  config.headers.set('X-Correlation-Id', uuidv4());
  config.headers.set('X-App-Version', __BOBTAIL_APP_VERSION__);
  return config;
}

export async function addAuth0AccessToken (config: InternalAxiosRequestConfig) {
  try {
    const accessToken = Cookies.get(CUSTOM_AUTH_NAME);
    config.headers.set('Authorization', `Bearer ${accessToken}`);
  } catch (e) {
    console && console.log(e);
  }
  return config;
}

async function mapHttpResponseError (error: unknown) {
  captureException(error);
  if (isAxiosError<OnboardingApiError>(error)) {
    const onboardingApiError = new OnboardingApiError({
      code: error.response?.data.code || UNKNOWN_ONBOARDING_API_ERROR_CODE,
      error: error.response?.data.error,
      message: (error.response?.data.message || ""),
      parameters: error.response?.data.parameters,
      statusCode: error.response?.data.statusCode || error.response?.status,
      traceId: error.response?.data.traceId,
    });
    throw onboardingApiError;
  }
  throw error;
}

export function setupInterceptors (httpClient: AxiosInstance) {
  httpClient.interceptors.request.use(addRequestIdHeader);
  httpClient.interceptors.request.use(addAuth0AccessToken);
  httpClient.interceptors.response.use(response => response, mapHttpResponseError);
}
